import {Component, OnInit} from '@angular/core';
import {Session} from "../../../../services/session.service";
import {ApiCallService} from "../../../../services/api-call.service";
import {ErrorMessageService} from "../../../../services/error-message.service";
import {AuthService} from "../../../../services/auth.service";
import {Router} from "@angular/router";


@Component({
    selector: 'app-impersonate',
    templateUrl: './impersonate.component.html',
    styleUrls: ['./impersonate.component.scss'],
    standalone: false
})
export class ImpersonateComponent implements OnInit {
  public impersonatedUsername:string;
  showMenu:boolean = false;


  constructor(
    private session:Session,
    private apiCall: ApiCallService,
    private errorMessage: ErrorMessageService,
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
  }

  openMenu() {
    this.showMenu = !this.showMenu;
  }

  updateUser(userName:string){
    this.impersonatedUsername = userName;
  }

  impersonate(userName:string){
    if(userName) {
      this.apiCall.getData( '/aeAMSimpersonateUser/', { usernameOverride: userName } )
        .subscribe( ( response ) => {
          if( response.success ) {
            let user = response.data[ 0 ].dataSet;
            this.session.impersonateUser( user );
            this.authService.setAuthObservable(true);
            this.router.navigate(['/home']);
          } else {
            this.errorMessage.showErrorModal( "There was a problem with impersonating user " + userName, response.dataError )
          }
        } )
    }
  };

  stopPropagation(event){
    event.stopPropagation();
  }

}
